import { useBooleanFlagValue } from '@openfeature/react-sdk';

import { Roles } from '../../../../constants';
import { FeatureFlags } from '../../../../constants/featureFlags';
import { areUserRolesIn } from '../../../../helpers';
import { PROVIDER_SSN_ALLOWED_ROLES } from '../constants';
import { useLoadProviderDetails } from './useLoadProviderDetails';
import { useProviderDetailsState } from './useProviderDetailsState';

export function useProviderDetailsPage() {
  useLoadProviderDetails();
  const { user } = useProviderDetailsState();
  const questionnaireEnabled = useBooleanFlagValue(FeatureFlags.QUESTIONNAIRE_ENABLED, false);

  return {
    showClinicalStatusSection: areUserRolesIn(user?.roles, [
      Roles.Admin,
      Roles.OnboardingCoordinator,
    ]),
    showQuestionnaireManagement:
      questionnaireEnabled &&
      areUserRolesIn(user?.roles, [
        Roles.Admin,
        Roles.ClientSuccessManager,
        Roles.OnboardingCoordinator,
      ]),
    showSsnSection: areUserRolesIn(user?.roles, PROVIDER_SSN_ALLOWED_ROLES),
  };
}
